import { axiosInstance } from "../../../Services";

export const GetInventoryServiceMap = async () => {
  try {
    const res = await axiosInstance.get(`/internal/form/inventory_service_map`, {
      headers: {
        "x-api-key": `${localStorage.getItem('token')}`,
      },
    });
    return res;
  } catch (error) {
    throw error;
  }
};